import React, { useContext, useEffect, useRef } from 'react';
import { ThreeDots } from 'react-loader-spinner'

import { SettingsContext } from '../App';
import antMailImage from './images/Icon_Info.png';
import antCoinImage from './images/AntCoin.png';
import antFoodImage from './images/AntFood.png';
import settingsIcon from './images/Settings.png';
// import treasuryShareImage from './images/Icon_Gold.png';
import useSolanaWeb3 from '../hooks/useSolanaWeb3'; // Updated import
import { LoadingDots } from './UI/LoadingDots';
import { useSelector } from 'react-redux';
import { selectAppBalances } from '../store/appSlice';
import PlusMinusIcon from './PlusMinusIcon';


function MenuTop({ changeActiveComponent, setWalletAddress }) {
  const { wallet } = useSolanaWeb3();
  const { toggleSettings } = useContext(SettingsContext);

  const appStore = useSelector(selectAppBalances)


  // Get the wallet address, if connected
  const address = wallet.connected ? wallet.publicKey.toString() : "";

  useEffect(() => {
    if (wallet.connected) {
      setWalletAddress(wallet.publicKey.toString());
    } else {
      setWalletAddress('');
    }
  }, [wallet, setWalletAddress]);

  return (
    <div className="menu-top">
      <div className="user-connected">
        <div className="user-connected-image"><img src={antMailImage} alt="Ant Mail" /></div>
        <div className="user-connected-text"><p>Connected Wallet:</p>
        <p className="connected-address cursor-pointer">{address ? address.slice(0, 6) + "..." + address.slice(-4) : ""}</p></div>
      </div>
      <div className="balance-container">
        <div className="balance">
          <div className="balance-image"><img src={antCoinImage} alt="Ant Coin" /><button id="balanceadd" onClick={() => window.open('https://raydium.io/swap/?inputCurrency=sol&outputCurrency=4WRST6Q2yyDP1p7Bqszg8PAAoj8j69cj7QY4QLn5Aq3o&fixed=in', '_blank')}><PlusMinusIcon /></button></div>
          <p className="balance-amount">{
            appStore.antCoinBalance !== undefined ? appStore.antCoinBalance?.toFixed(2):
            <LoadingDots />
            }
            </p>
        </div>
        <div className="balance">
        <div className="balance-image"><img src={antFoodImage} alt="Ant Food" /><button id="balanceadd" onClick={() => changeActiveComponent('shop')}><PlusMinusIcon /></button></div>
          <p className="balance-amount">{appStore.antFoodBalance !== undefined ? appStore.antFoodBalance :<LoadingDots />}</p>
        </div>
      </div>
    </div>
  );
}

export default MenuTop;